import { xLocalStorage } from "@/core/services/xLocalStorage.service";

const ACCESS_TOKEN_KEY = "access_token";

export const getAccessToken = () => {
  return xLocalStorage.get(ACCESS_TOKEN_KEY);
};
export const saveToken = token => {
  xLocalStorage.set(ACCESS_TOKEN_KEY, token);
};
export const destroyAllTokens = () => {
  xLocalStorage.remove(ACCESS_TOKEN_KEY);
};
export default {
  getAccessToken,
  saveToken,
  destroyAllTokens
};
